import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TimeCardFeatureComponent } from './time-card-feature/time-card-feature.component';
import { TimeCardPresenterComponent } from './time-card-presenter/time-card-presenter.component';
import { StoreModule } from '@ngrx/store';
import * as fromTimeCard from './store/time-card.reducer';
import { EffectsModule } from '@ngrx/effects';
import { TimeCardEffects } from './store/time-card.effects';
import { IAuthorizedTasksEffects } from './store/iauthorized-task.effects';
import { WeeklySummaryEffects } from './store/weekly-summary.effects';
import { DirectReportsWithTimeStatusEffects } from './store/direct-reports-with-time-status.effects';
import * as fromAuthorizedTaskR from './store/iauthorized-task.reducer';
import * as fromWeeklySummaryR from './store/weekly-summary.reducer';
import * as fromdrwtsR from './store/direct-reports-with-time-status.reducer';
import * as fromTimcardDoc from './store/time-card-documentation.reducer';
import { ManagementActionEffects } from './store/management-action.effects';
import { TimeCardDocumentationFeatureComponent } from './time-card-documentation-feature/time-card-documentation-feature.component';
import { TimeCardDocumentationEffects } from './store/time-card-documentation.effects';
import { EfaactMaterialModule } from '../efaact-material/efaact-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserSelectorModule } from '../user-selector/user-selector.module';
import { MatRadioModule } from '@angular/material/radio';
import {
    FileUploadModule,
    MessagesModule
} from '../shared/efaact-primeng.module';
import {
    TimeCardDocumentationPresenterComponent,
    ReduceMaxPipe,
    ReduceNumberPipe,
    ClassListPipe,
    FilterPipe
} from './time-card-documentation-presenter/time-card-documentation-presenter.component';
import { SharedModule } from '../shared/shared.module';
import { TimeCardSubmitEffects } from './store/time-card-submit.effects';
import { EntityDataService } from '@ngrx/data';
import * as fromDataServices from '../data-services';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(fromTimeCard.timeCardsFeatureKey, fromTimeCard.reducer),
        StoreModule.forFeature(fromAuthorizedTaskR.iAuthorizedTasksFeatureKey, fromAuthorizedTaskR.reducer),
        StoreModule.forFeature(fromWeeklySummaryR.weeklySummariesFeatureKey, fromWeeklySummaryR.reducer),
        StoreModule.forFeature(fromdrwtsR.directReportsWithTimeStatusesFeatureKey, fromdrwtsR.reducer),
        StoreModule.forFeature(fromTimcardDoc.timeCardDocumentationsFeatureKey, fromTimcardDoc.reducer),
        EffectsModule.forFeature([
            TimeCardEffects,
            IAuthorizedTasksEffects,
            WeeklySummaryEffects,
            DirectReportsWithTimeStatusEffects,
            TimeCardDocumentationEffects,
            ManagementActionEffects,
            TimeCardDocumentationEffects,
            TimeCardSubmitEffects
        ]),
        EfaactMaterialModule,
        FormsModule,
        ReactiveFormsModule,
        UserSelectorModule,
        MatRadioModule,
        SharedModule,
        FileUploadModule,
        MessagesModule
    ],
    declarations: [
        TimeCardDocumentationFeatureComponent,
        TimeCardDocumentationPresenterComponent,
        TimeCardFeatureComponent,
        TimeCardPresenterComponent,
        ReduceMaxPipe,
        ReduceNumberPipe,
        FilterPipe,
        ClassListPipe
    ]
})
export class TimeCardModule {
    constructor(
        entityDataService: EntityDataService,
    ) {

    }
}
